var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-table"},[_c('InstallmentsTable',{attrs:{"installments":_vm.installments,"onEdit":installment => _vm.onEdit(_vm.bill?.id, _vm.bill?.bill_items?.length),"getInstallments":_vm.getBills},on:{"selected-bills":_vm.selectedBills}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }